import type { LucideIconData } from 'lucide-angular';

/**
 * Lucide `folder-bookmark` icon (ISC license, https://lucide.dev/icons/folder-bookmark).
 * Registered as custom icon data because the installed `lucide-angular` (1.0.0, the latest
 * published) does not ship it. Drop this file and import the icon from `lucide-angular`
 * once a release includes it.
 */
export const FolderBookmark: LucideIconData = [
  [
    'path',
    { d: 'M12 6v7.751a.25.25 0 00.407.195l2.28-1.834a.5.5 0 01.627 0l2.28 1.834a.25.25 0 00.406-.195V6' },
  ],
  [
    'path',
    {
      d: 'M20 20a2 2 0 002-2V8a2 2 0 00-2-2h-7.9a2 2 0 01-1.69-.9L9.6 3.9A2 2 0 007.93 3H4a2 2 0 00-2 2v13a2 2 0 002 2z',
    },
  ],
];
